import {
    Cart,
    SelectedEnvelope,
} from '../components/Donee/components/Capsules/Envelopes';

export const getTotalCartAmount = (
    envelopes: Cart['envelopes'],
): { amount: number; envelopes: SelectedEnvelope[] } => {
    let amount = 0;
    const result = [];
    for (const key in envelopes) {
        if (key === 'new') {
            continue;
        }
        const e = envelopes[key];
        if (!e) {
            continue;
        }
        result.push(e);
        amount += e.amount;
    }
    return { amount, envelopes: result };
};
